"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StatusEffectsBar;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StatusEffectsBarModule = _interopRequireDefault(require("./StatusEffectsBar.module.scss"));

var _entities = require("../../../../entities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderAssociatedSkill(statusEffect) {
  var id = statusEffect.id,
      byClassSkill = statusEffect.byClassSkill,
      isAboutToExpire = statusEffect.isAboutToExpire;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    key: id,
    className: (0, _classnames.default)(_StatusEffectsBarModule.default.entry, isAboutToExpire && _StatusEffectsBarModule.default.blink)
  }, /*#__PURE__*/_react.default.createElement(_entities.ClassSkill, {
    skill: byClassSkill
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _StatusEffectsBarModule.default.time
  }, "42"), " "));
}

function StatusEffectsBar(_ref) {
  var _ref$statusEffects = _ref.statusEffects,
      statusEffects = _ref$statusEffects === void 0 ? [] : _ref$statusEffects,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var buffs = statusEffects.filter(function (effect) {
    return !effect.isNegative;
  });
  var curses = statusEffects.filter(function (effect) {
    return effect.isNegative;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_StatusEffectsBarModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _StatusEffectsBarModule.default.buffs
  }, buffs.map(function (buff) {
    return renderAssociatedSkill(buff);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _StatusEffectsBarModule.default.curses
  }, curses.map(function (curse) {
    return renderAssociatedSkill(curse);
  })));
}